module.exports = __webpack_public_path__ + "static/media/about.539c16d8.jpg";